// The if statement is for if we are in test mode (no meta tag or forgery protection in test mode)

export default function csrfToken() {
  const metaTag = document.querySelector('head meta[name="csrf-token"]') as any;
  if (!!metaTag) {
    return metaTag.content;
  }
  return '';
}
